import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useContext } from 'react';
import { SortableCards } from 'console/shared/components/features/sortable-cards';
import { DeviceConfig } from 'console/shared/contexts/device/config/types';
import * as S from './styles';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { select_ui_settings } from 'console/redux/settings-actions';
import { LegacyThumblers } from './thumblers/legacy';
import { HeatingModeView } from './heating-mode';
export const HeatingModes = memo(function HeatingModes(props) {
    const { panel_key, config } = props;
    const { support_service_mode, is_legacy_device, is_climatic } = useContext(DeviceConfig);
    const component = useCallback((heating_mode_config) => (_jsx(HeatingModeView, { config: heating_mode_config })), [support_service_mode, is_climatic]);
    const { tab_cards_size_multiplier = 1 } = useAppSelector(select_ui_settings);
    return (_jsxs(S.HeatingModes, { length: config.length, multiplier: tab_cards_size_multiplier, "data-tooltip": `${panel_key}-card`, children: [_jsx(SortableCards, { panel_key: panel_key, list: config, component: component, min_width: 110, min_height: 70 }), is_legacy_device && _jsx(LegacyThumblers, {})] }));
});
